import { ShieldCheck, Truck, Undo2, Leaf, Mail } from "lucide-react";

const ICONS = [ShieldCheck, Truck, Undo2, Leaf, Mail];

export const Reassurance = ({ items }) => (
  <ul className="mt-6 pt-5 border-t border-stone-200 space-y-3" data-testid="checkout-reassurance">
    {items.map((txt, i) => {
      const Icon = ICONS[i % ICONS.length];
      return (
        <li key={txt} className="flex items-start gap-3 text-[12px] text-stone-600 leading-snug">
          <span className="w-7 h-7 rounded-full bg-[#FAF7F2] border border-stone-200 flex items-center justify-center shrink-0"><Icon size={13} className="text-[#4A624E]" /></span>
          <span className="pt-1">{txt}</span>
        </li>
      );
    })}
  </ul>
);

export const FreeShippingBar = ({ subtotal, threshold, label, reached }) => {
  const pct = Math.min(100, Math.round((subtotal / threshold) * 100));
  return (
    <div className="mt-4" data-testid="checkout-shipping-bar">
      <p className={`text-[11px] ${pct >= 100 ? "text-[#4A624E]" : "text-stone-500"}`}>{pct >= 100 ? reached : label}</p>
      <div className="mt-2 h-1 rounded-full bg-stone-200 overflow-hidden"><div className="h-full bg-[#4A624E] transition-[width] duration-500" style={{ width: `${pct}%` }} /></div>
    </div>
  );
};
